var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0C16.2 0 0 16.1 0 36C0 55.9 16.2 72 36 72C55.9 72 72 55.9 72 36C72 16.1 55.8 0 36 0ZM36 68C18.3 68 4 53.7 4 36C4 18.3 18.3 4 36 4C53.7 4 68 18.4 68 36C68 53.7 53.7 68 36 68Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 25.4001L46.7 22.6001C42.6 26.6001 39 30.1001 36 33.2001C33 30.2001 29.4 26.6001 25.4 22.6001L22.6 25.4001C22.6 25.4001 27.7 30.5001 33.2 36.0001C26.2 43.0001 22.6 46.6001 22.5 46.7001L25.3 49.5001C25.4 49.4001 30.5 44.3001 35.9 38.9001C41.3 44.3001 46.4 49.4001 46.5 49.5001L49.3 46.7001C49.3 46.7001 45.6 43.0001 38.6 36.0001C44.3 30.5001 49.5 25.4001 49.5 25.4001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrError);
export default __webpack_public_path__ + "static/media/ubr-error.7730fe5bf037aa1d627a6b44dd92a935.svg";
export { ForwardRef as ReactComponent };